/* global axios */
import ApiClient from './ApiClient';

class FlowsAPI extends ApiClient {
  constructor() {
    super('flows', { accountScoped: true });
  }

  // Inicia o flow proativamente para uma audiencia (etiquetas/manual/todos).
  trigger(id, payload) {
    return axios.post(`${this.url}/${id}/trigger`, payload);
  }

  // Relatorio de execucoes (sessoes) do flow.
  sessions(id) {
    return axios.get(`${this.url}/${id}/sessions`);
  }
}

export default new FlowsAPI();
